import { createElementBlock, openBlock, createStaticVNode } from "vue";
/* empty css        */
import _export_sfc from "./index63.js";
const _sfc_main = {};
const _hoisted_1 = {
  class: "trh",
  "aria-hidden": "true"
};
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createStaticVNode('<span class="trh-h trh-h--n" data-v-e8877167></span><span class="trh-h trh-h--s" data-v-e8877167></span><span class="trh-h trh-h--w" data-v-e8877167></span><span class="trh-h trh-h--e" data-v-e8877167></span><span class="trh-c trh-c--nw" data-v-e8877167></span><span class="trh-c trh-c--ne" data-v-e8877167></span><span class="trh-c trh-c--sw" data-v-e8877167></span><span class="trh-c trh-c--se" data-v-e8877167></span>', 8)
  ])]);
}
const TableResizeHandles = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-e8877167"]]);
export {
  TableResizeHandles as default
};
//# sourceMappingURL=index17.js.map
